App.StaticPage = DS.Model.extend
  name:      DS.attr "string"
  slug:      DS.attr "string"
  page_type: DS.attr "string"
  position:  DS.attr "number"

  meta_h1:          DS.attr "string"
  meta_title:       DS.attr "string"
  meta_description: DS.attr "string"
  
  title:   DS.attr "string"
  excerpt: DS.attr "string"
  photo:   DS.attr 'mixed'

  
  show_in_web:   DS.attr "boolean"
  show_in_app:   DS.attr "boolean"

  settings_json: DS.attr "string"
  content:       DS.attr "string"

  parent: DS.belongsTo 'staticPage',  async: true, inverse: 'childs' 
  childs: DS.hasMany 'staticPage', async: true,   inverse: 'parent' 



  avatarPlaceholder: 'images/dish-placeholder@2x.png'
  imageStyle: (->
    photo = @get('photo.large')

    if photo?
      return "background-color: grey; background-image: url(#{ photo })".htmlSafe()
    else
      return "background-image: url(#{ @get('avatarPlaceholder') })".htmlSafe()
  ).property('photo', 'photo.large')



  uploadPhoto: (file) ->
    promise = @fileUpload('photo', file)
    promise.then => @notifyRecordChange()
    promise

  deletePhoto: ->
    promise= @nonRESTAction('DELETE', 'photo')
    promise.then => @notifyRecordChange()
    promise
